export const chargebeeConfig = {
  style: {
    // Styles for default field state
    base: {
      color: '#333333',
      fontWeight: '400',
      fontFamily: 'Inter, Helvetica Neue, sans-serif',
      fontSize: '16px',

      '::placeholder': {
        color: '#C4C4C4',
      },
    },

    // Styles for invalid field state
    invalid: {
      color: '#e41029',

      ':focus': {
        color: '#e44d5f',
      },

      '::placeholder': {
        color: '#FFCCA5',
      },
    },
  },
  placeholder: {
    number: 'Card number',
    expiry: 'Expiry date (MM/YY)',
    cvv: 'CVC',
  },
  fonts: ['https://fonts.googleapis.com/css2?family=Inter&display=swap'],
};
